HAS_CART = true
window.HAS_CART = HAS_CART


let mulberrySelectors = {
  pdpForm: ".qty-submit",
  elementToAppendTo: '.swatch.clearfix',
  clickOrFormSubmit: 'click'
}


async function refreshCart() {
  // call something like Shopify.theme.cart.refresh()
  // this one refreshes automatically
  
  // don't edit below here
  if(window.HAS_CART) {
    await updateCartWidgetInfo()
    setTimeout(mulberryShop.cart.render, 600)
  }
  return
}

function getCurrentlySelectedVariant(variants) {
  selectedVariant = variants.find(i => i.id == mulberryShop.selectedVariantId)
  return selectedVariant
}

function setupCustomVariantChange() {
  // something to get product Info
  //productInfo = undefined
  
  // this is needed if mulberryshop variant changes aren't working
  // variantChangeEvent = new CustomEvent("mulberry-shopify:variant-change", {detail: productInfo})
  // document.dispatchEvent(variantChangeEvent)
}

async function updateCartWidgetInfo() {
  
  cartSelectors = {
    cartRow: '.rebuy-cart__flyout-item',
    itemProductTitle: '.rebuy-cart__flyout-item-product-title',
    itemVariantTitle: '.rebuy-cart__flyout-item-variant-title',
    insertLocation: '.rebuy-cart__flyout-item-quantity-widget'
  }
  
  
  document.querySelectorAll(cartSelectors.cartRow).forEach(function(item){
    productTitle = $(item).find(cartSelectors.itemProductTitle).text()
    if(productTitle.includes('Mulberry Protection')) {
      item.setAttribute('style', 'display: none;')
    }
    else {
      item.setAttribute('style', '')
    }
  })
  cartResp = await fetch('/cart.json')
  cart = await cartResp.json()
  
  
  
  cartMapping = {}
  cart.items.forEach(function(item) {
    productVariantCombo = item.product_title + " ||| " + item.variant_title
    cartMapping[productVariantCombo] = item.variant_id
  })
  
  
  
  // our function to add <warranty-details> and variant id 
  $("warranty-details").each(function(idx, item){$(item).remove()})
  document.querySelectorAll(cartSelectors.cartRow).forEach(function(item){
    productTitle = $(item).find(cartSelectors.itemProductTitle).text()
    variantTitle = $(item).find(cartSelectors.itemVariantTitle).text()
    variantId = cartMapping[productTitle + " ||| " + variantTitle]
    item.setAttribute('data-mulberry-variant-id', variantId)
    if(productTitle.includes('Mulberry Protection')) {
      item.setAttribute('style', 'display: none;')
    }
    else {
      item.setAttribute('style', '')
    }
    var $newWarrantyDetails = $("<warranty-details/>").attr('data-variant-id', variantId)
    var $newSpan = $("<span/>")
    $newSpan.css({'line-height': '1rem', 'font-size': '10px'})
    $newSpan.append($newWarrantyDetails)
    $newSpan.insertBefore($(item).find(cartSelectors.insertLocation))
  }) 

}


async function mulberryPdpInit() {

  HAS_MODAL = mulberry.core.settings.has_modal
  HAS_INLINE = mulberry.core.settings.has_inline

  if(window.location.pathname.indexOf("/products/") === -1) {
    return
  }

  if(!HAS_MODAL && !HAS_INLINE) {
    return
  }

  setupCustomVariantChange()
  
  let mulberryDiv = document.createElement('div')
  mulberryDiv.classList.add('mulberry-inline-container')
  $(mulberrySelectors.elementToAppendTo).append(mulberryDiv)
  
  let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
  let product = response.product;
  let selectedVariant = getCurrentlySelectedVariant(product.variants)
  const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
  })
  
  if(offers.length === 0){
    document.addEventListener("shopify:cart-add", function() {
      setTimeout(function(){ mulberryShop.cart.render() }, 650);
    })
    return
  }

  const { settings } = mulberry.core;
  if(HAS_INLINE){
    window.pdpInline = await mulberry.inline.init({
        offers: offers, 
        settings: mulberry.core.settings,
        selector: '.mulberry-inline-container',
        onWarrantyToggle: async (warranty) => {
          mulberry.inline.isSelected = warranty.isSelected
          warrantyAdded = false
          if(warranty.isSelected) {
            window.selectedOffer = warranty.offer
          }
          else {
            window.selectedOffer = null
          }
        }
      })
  }
  if(HAS_MODAL){
    window.pdpModal = await mulberry.modal.init({
        offers: offers, 
        settings: mulberry.core.settings,
        onWarrantySelect: async (warranty) => {
          const result = await mulberryShop.getWarrantyVariant(warranty);
          await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, warranty);
          mulberry.modal.close();
          removeAndSyncWarranties()
        },
        onWarrantyDecline: () => {
          mulberry.modal.close();
          removeAndSyncWarranties()
        }
      })
  }


  document.addEventListener('mulberry-shopify:variant-change', async function(e) {
    selectedVariant = product.variants.find(i => i.id == e.detail.variantId)
    const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
    })
    
    if(HAS_INLINE){
      window.pdpInline.updateOffer(offers);
    }
    if(HAS_MODAL) {
      window.pdpModal.updateOffer(offers)
    }

  });
  
  //$pdpForm = $(mulberrySelectors.pdpForm)
  //$pdpForm.submit(async function(){
  warrantyAdded = false
  $(mulberrySelectors.pdpForm).on(mulberrySelectors.clickOrFormSubmit, async function(e) {
    if(HAS_INLINE && window.selectedOffer && !warrantyAdded) {
      //e.preventDefault()
      setTimeout(async function(){
        if(!warrantyAdded) {
       const result = await mulberryShop.getWarrantyVariant(window.selectedOffer);
       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, window.selectedOffer);
       removeAndSyncWarranties()
       window.pdpInline.deselectOffer()
       window.selectedOffer = null
       warrantyAdded = true}
      }, 250)
      //$pdpForm.submit()
      return
    }
    else if(HAS_MODAL) {
      //e.preventDefault()
      window.pdpModal.open()
      return
    }

  })
}









function setupAjaxListeners() {
    // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
    // Since we cant create globals we test for the XMLHttpRequest overwrite
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock fetch() in order to determine if we should mock then() as well
        var mbFetch = fetch;
        fetch = function() {
            var url = arguments[0];
            var body = '';
            if ((arguments.length > 1) && (typeof arguments[1].body !== 'undefined'))
            {
                body = arguments[1].body;
            }
            var promise = mbFetch.apply(this,arguments);
            if (url && url.indexOf('cart/change') !== -1) {
                //If its a product being added to cart we add a function to track it
                promise = promise.then(function (response) {
                    if (response.ok) {
                        //trackAjaxAddToCart(body, response.clone().json());
                    }
                    return response;
                });
            }
            return promise;
        };
    }
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
        XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            var url = arguments[1];
            if (url && ( (url.includes('cart/change')) || (url.includes('cart/add')) || (url.includes('cart/update')) )) {
                // We mock the instance's send method if the request is to the "add to the cart" url.
                this.mbSend = this.send;
                this.send = function (value) {
                    try {
                        if (value) {
                            var self = this; // The xhttp request object

                            var trackOnSuccess = function () {
                                if (self.readyState === 4 && self.status === 200) {
                                  if(self.responseURL !== undefined) {
                                    if(self.responseURL.includes('cart/add')){
                                      addCustomEvent = new CustomEvent("shopify:cart-add")
                                      document.dispatchEvent(addCustomEvent)
                                    }
                                    if(self.responseURL.includes('cart/change')) {
                                      changeCustomEvent = new CustomEvent("shopify:cart-change")
                                      document.dispatchEvent(changeCustomEvent)
                                    }
                                    if(self.responseURL.includes('cart/update')) {
                                      updateCustomEvent = new CustomEvent("shopify:cart-update")
                                      document.dispatchEvent(updateCustomEvent)
                                    }
                                  }
                                }
                            };

                            if (typeof self.addEventListener !== 'undefined') {
                                self.addEventListener('readystatechange', trackOnSuccess);
                            } else {
                                if (typeof self.onreadystatechange !== 'undefined' && self.onreadystatechange !== null) {
                                    // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                                    self.mbOnreadystatechange = self.onreadystatechange;
                                    self.onreadystatechange = function () {
                                        self.mbOnreadystatechange();
                                        trackOnSuccess();
                                    };
                                } else {
                                  // If there is no onreadystatechange callback, we can safely set it.
                                  self.onreadystatechange = trackOnSuccess;
                                }
                            }
                        }
                    } catch(e) {
                        // if something goes wrong tracking the addToCart,
                        // we just ignore it and prevent the website from breaking.
                        console.log(e);
                    }
                    this.mbSend(value);
                };
            }
            this.mbOpen.apply(this, arguments);
        };
    }
}


async function removeAndSyncWarranties(refresh=false) {
  await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      cart.json().then(function (firstCart) {
        mulberryShop.removeDetachedWarranty(firstCart)// Remove Warranties First 
        .then(newCart => {
          mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
          .then(content => {
            if(refresh){
              window.location.reload()
            }
            else{
              //setTimeout(refreshCart, 2500)
            }
          })
        })
      });
    })
}

document.addEventListener('rebuy:cart.enriched', refreshCart)


document.addEventListener('mulberry-shopify:loaded', async function(e) {
  if(document.location.href.includes('/products/')) {
    mulberryPdpInit()
  }
  mulberryShop.cart.init()
  removeAndSyncWarranties()
  setupAjaxListeners()
})

document.addEventListener('shopify:cart-change', function() {
  removeAndSyncWarranties()
})

document.addEventListener('mulberry-shopify:warranty-added', async function() {
  removeAndSyncWarranties()
})
